<div class="container-fluid px-3 py-2">
  <!-- Top bar: search + results + sort -->
  <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
    <!-- Search -->
    <div class="flex-grow-1">
      <div class="input-group">
        <input
          type="search"
          class="form-control border-end-0"
          [placeholder]="'admin.common.searchPlaceholder' | translate"
          [value]="searchTerm()"
          (input)="onSearchInput($event)"
        />
        <span class="input-group-text bg-white border-start-0">
          <i class="fas fa-search"></i>
        </span>
      </div>
    </div>

    <!-- Page size -->
    <div
      class="d-flex align-items-center gap-2 input-group input-group-sm w-auto"
    >
      <span class="label small">
        {{ "admin.common.pageSize" | translate }}
      </span>
      <select
        class="form-select"
        [value]="pageSize()"
        (change)="onPageSizeSelect($event)"
      >
        <option [value]="20">20</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select>
    </div>

    <!-- Sort -->
    <div
      class="d-flex align-items-center gap-2 input-group input-group-sm w-auto"
    >
      <span class="label small">
        {{ "admin.common.order" | translate }}
      </span>
      <select
        class="form-select"
        [value]="sortOrder()"
        (change)="onSortSelect($event)"
      >
        <option value="latest">
          {{ "admin.common.sortLatest" | translate }}
        </option>
        <option value="oldest">
          {{ "admin.common.sortOldest" | translate }}
        </option>
        <option value="name_az">
          {{ "admin.common.sortNameAz" | translate }}
        </option>
        <option value="name_za">
          {{ "admin.common.sortNameZa" | translate }}
        </option>
      </select>
    </div>
  </div>

  <div class="row g-4 align-items-start">
    <!-- Left column: Filters -->
    <aside class="col-12 col-md-4 col-lg-3 align-self-start">
      <div class="card">
        <div class="card-header px-3 filter-card-title">
          {{ "admin.common.filter" | translate }}
        </div>
        <hr class="filter-divider my-0 mx-3" />

        <div class="card-body px-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="status-caption">
              {{ "admin.common.status" | translate }}
            </span>

            <span class="status-clear">
              <app-button
                [ariaLabel]="'admin.contacts.actions.clearFilter' | translate"
                [iconClass]="'fa-solid fa-minus text-gray-700'"
                [btnClass]="
                  'btn btn-link btn-sm p-0 shadow-none border-0 d-inline-flex align-items-center'
                "
                (clicked)="onClearStatusOnly()"
              />
            </span>
          </div>

          <div class="d-flex flex-column gap-2 mb-3">
            @for (status of statusItems(); track status.id) {
            <label
              class="form-check d-flex align-items-center gap-2 status-item"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="isDraftChecked(status.id)"
                (change)="
                  onStatusCheckboxChange(status.id, $any($event.target).checked)
                "
              />
              <span class="form-check-label status-item-label">
                {{ status.key | translate }}
              </span>
            </label>
            }
          </div>

          <div class="d-grid gap-2">
            <button
              type="button"
              class="btn btn-primary btn-filter"
              (click)="onApplyFiltersClick()"
            >
              <i class="fas fa-filter me-2"></i>
              {{ "admin.contacts.actions.applyFilter" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-link text-decoration-none btn-clear"
              (click)="onClearFiltersClick()"
            >
              {{ "admin.contacts.actions.clearFilter" | translate }}
            </button>
          </div>
        </div>
      </div>
    </aside>

    <!-- Right column: Project list -->
    <main class="col-12 col-lg-8 px-0">
      @if (isLoading()) {
      <div class="spinner">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
      } @else {
      <app-project-grid [projects]="visibleProjects()"></app-project-grid>

      @if (!visibleProjects().length) {
      <div class="text-muted small mt-3 px-3">
        {{ "admin.common.noResults" | translate }}
      </div>
      } }
    </main>
  </div>
</div>
